export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1758541213979-fe8c9996e197?crop=entropy&cs=srgb&fm=jpg&ixid=M3w5MTMyMXwwfDF8c2VhcmNofDJ8fGNvdXJ0cm9vbSUyMGxhd3llciUyMGp1c3RpY2UlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzg4Mzg1NTE4fDA&ixlib=rb-4.1.0&q=85",
  columns: "https://images.unsplash.com/photo-1780445333331-32049679a0be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w5MTMyMXwwfDF8c2VhcmNofDN8fGNvdXJ0cm9vbSUyMGxhd3llciUyMGp1c3RpY2UlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzg4Mzg1NTE4fDA&ixlib=rb-4.1.0&q=85",
  boardroom: "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1800&q=80",
  skyline: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1800&q=80",
};

export const NAV_LINKS = [
  { href: "#framework", testid: "nav-framework-link" },
  { href: "#advantage", testid: "nav-advantage-link" },
  { href: "#workflow", testid: "nav-workflow-link" },
  { href: "#panel", testid: "nav-panel-link" },
  { href: "#pricing", testid: "nav-pricing-link" },
  { href: "#press", testid: "nav-press-link" },
];

export const ADVANTAGE_ICONS = ["Cpu", "Award", "ShieldCheck", "Globe"];
export const ADVANTAGE_SPANS = ["lg:col-span-7", "lg:col-span-5", "lg:col-span-5", "lg:col-span-7"];

export const PANEL = [
  {
    name: "Hon. Evelyn Vance, KC",
    cases: "420+",
    image: "https://images.unsplash.com/photo-1581065178047-8ee15951ede6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxleGVjdXRpdmUlMjBwb3J0cmFpdCUyMHByb2Zlc3Npb25hbCUyMGJ1c2luZXNzfGVufDB8fHx8MTc4ODM4NTUyMXww&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Dr. Marcus Thorne, LL.D.",
    cases: "310+",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Justice Clara Lin-Schmid",
    cases: "550+",
    image: "https://images.unsplash.com/photo-1758518727888-ffa196002e59?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwyfHxleGVjdXRpdmUlMjBwb3J0cmFpdCUyMHByb2Zlc3Npb25hbCUyMGJ1c2luZXNzfGVufDB8fHx8MTc4ODM4NTUyMXww&ixlib=rb-4.1.0&q=85",
  },
];

export const TIER_META = [
  { fee: "$2,950", max: 250000, highlight: false },
  { fee: "$7,500", max: 2500000, highlight: true },
  { fee: "Custom", max: Infinity, highlight: false },
];

export const JURISDICTIONS = [
  "England & Wales",
  "New York, United States",
  "Singapore",
  "Switzerland",
  "France",
  "Germany",
  "UAE — DIFC",
  "Hong Kong SAR",
  "Netherlands",
  "Other / Multi-Jurisdictional",
];

export const QUICK_LINKS = [
  { href: "#framework", testid: "footer-link-framework" },
  { href: "#workflow", testid: "footer-link-ethics" },
  { href: "#panel", testid: "footer-link-panel" },
  { href: "#pricing", testid: "footer-link-pricing" },
  { href: "#advantage", testid: "footer-link-advantage" },
  { href: "#press", testid: "footer-link-press" },
];
